// Mock data for ADA website (Rebranded from ADA)
// Alliance Démocratique Africaine - Constructive. Contributive.

export const siteContent = {
  fr: {
    nav: {
      home: "Accueil",
      ada: "ADA",
      posture: "Notre posture",
      approach: "Approche",
      proposals: "Propositions",
      news: "Actualités",
      join: "Rejoindre",
      microdon: "Micro-don",
      // Legacy - kept for compatibility
      manifesto: "Le Manifeste",
      vision: "Notre Vision",
      territories: "Territoires",
      projects: "Sécurité, Jeunesse, Numérique",
      about: "À Propos"
    },
    hero: {
      title: "Une Nation. Des territoires forts. Un avenir souverain.",
      subtitle: "Refonder l'État. Libérer les territoires. Construire une République économique décentralisée.",
      // New hero questions slider
      questions: [
        "Où voulons-nous aller ensemble ?",
        "Que transmettons-nous à nos enfants ?",
        "Comment bâtir un État qui fonctionne ?",
        "Comment créer de la richesse sur nos territoires ?",
        "Quelle place pour notre jeunesse ?",
        "Comment réconcilier tradition et modernité ?"
      ]
    },
    posture: {
      teaser: {
        title: "Notre posture",
        text: "Constructive. Contributive.",
        link: "Lire la page"
      }
    },
    constat: {
      title: "Le constat",
      paragraphs: [
        "L'Afrique a gagné en stabilité. Mais nos modèles de gouvernance ont atteint leurs limites.",
        "Centralisation excessive, éloignement du pouvoir, fatigue démocratique, jeunesse en attente, territoires sous-exploités.",
        "Nos pays n'ont pas besoin de replâtrage. Ils ont besoin d'un nouveau contrat politique."
      ]
    },
    vision: {
      title: "La vision ADA",
      intro: "L'Alliance Démocratique Africaine propose une refondation lucide et assumée :",
      points: [
        "Un État stratège, recentré sur ses missions essentielles.",
        "Des territoires autonomes, producteurs de richesse.",
        "Des citoyens acteurs, responsables et protégés."
      ],
      conclusion: "La souveraineté ne se décrète plus depuis le sommet. Elle se construit, territoire par territoire."
    },
    pillars: {
      title: "Les trois piliers",
      items: [
        {
          title: "Refonder l'État",
          description: "Clarifier les rôles, restaurer l'autorité légitime, garantir la justice."
        },
        {
          title: "Libérer les territoires",
          description: "Donner aux provinces et aux villes les moyens de produire, investir et planifier."
        },
        {
          title: "Projeter la Nation",
          description: "Sécurité, jeunesse, numérique : préparer l'avenir sans dépendre."
        }
      ]
    },
    manifesto: {
      title: "Le Manifeste",
      intro: "Le Manifeste ADA est un texte fondateur. Il expose une vision cohérente, structurée, pensée pour le temps long.",
      cta: "Lire le Manifeste"
    },
    territories: {
      title: "Les territoires",
      lines: [
        "Chaque territoire compte.",
        "Chaque territoire produit.",
        "Chaque territoire contribue."
      ],
      conclusion: "Une fédération économique cohérente, bâtie à partir de la base."
    },
    cta: {
      discover: "Découvrir la vision",
      join: "Rejoindre",
      contribute: "Contribuer",
      readProposals: "Lire nos propositions"
    },
    manifestoPage: {
      title: "Le Manifeste",
      subtitle: "Une nation, un avenir",
      foundingText: "Le texte fondateur de l'Alliance Démocratique Africaine",
      intro: {
        salutation: "Aux Ivoiriennes et aux Ivoiriens",
        text: "Je m'adresse à vous simplement, sans promesse démesurée ni procès facile. J'ai la conviction que notre pays possède tout ce qu'il faut pour réussir : une jeunesse nombreuse et courageuse, des femmes et des hommes qui travaillent dur, une terre généreuse, et une histoire qui nous a appris la valeur du dialogue.",
        text2: "Mais j'ai aussi le sentiment, partagé par beaucoup, que la vie politique s'est trop souvent réduite à un affrontement stérile. D'un côté, ceux qui défendent tout; de l'autre, ceux qui critiquent tout. Entre les deux, un pays qui attend des solutions.",
        text3: "Cette lassitude, je la comprends. Elle naît de promesses répétées et rarement tenues, de débats qui tournent à l'invective, et d'un sentiment tenace que la politique se fait sans les citoyens plutôt qu'avec eux. Rien de tout cela n'est une fatalité.",
        text4: "C'est pourquoi j'ai voulu que l'Alliance Démocratique Africaine soit différente. Non pas un parti de plus, mais un parti de contribution: une force qui propose, qui construit, qui reconnaît ce qui fonctionne et corrige ce qui échoue. Ce manifeste expose ce que nous sommes, ce que nous croyons et ce à quoi nous nous engageons.",
        author: "Alpha O. Diallo",
        authorTitle: "Président de l'Alliance Démocratique Africaine",
        quote: "« Nous ne sommes pas là pour tout critiquer, mais pour tout améliorer. »"
      },
      sections: [
        {
          number: "I",
          title: "Notre constat",
          subtitle: "Le pays que nous voyons",
          paragraphs: [
            "La Côte d'Ivoire avance. Des routes se construisent, l'économie progresse, et le pays occupe une place de plus en plus importante dans la sous-région. Nous le disons sans réticence: ce qui est fait de bien doit être salué, d'où que cela vienne. C'est une question d'honnêteté, et c'est aussi la condition d'un débat public apaisé.",
            "Pour autant, les progrès mesurés à l'échelle nationale ne se ressentent pas toujours dans la vie quotidienne. Le coût de la vie pèse sur les ménages, en particulier sur les plus modestes, pour qui le panier de base devient chaque mois plus difficile à remplir. Les jeunes diplômés, formés au prix d'efforts considérables, peinent à trouver un premier emploi à la hauteur de leurs compétences.",
            "Dans de nombreuses localités, l'accès aux soins, à une école de qualité ou à des routes sûres demeure difficile. Les inégalités entre territoires restent fortes : ce qui va de soi dans la capitale reste un défi ailleurs. Et la corruption, lorsqu'elle persiste, décourage l'effort, fausse la concurrence et détourne des ressources qui devraient servir tous les citoyens.",
            "Ces réalités ne sont pas des fatalités. Elles appellent des réponses concrètes, méthodiques et évaluées — pas des slogans."
          ]
        },
        {
          number: "II",
          title: "Notre conviction",
          subtitle: "Une autre façon de faire de la politique",
          paragraphs: [
            "Nous croyons qu'un parti se juge à sa capacité à proposer, non à sa capacité à dénoncer. La critique est utile lorsqu'elle éclaire et ouvre une alternative; elle devient stérile lorsqu'elle tient lieu de programme. L'ADA fait le choix inverse : celui de la contribution.",
            "Contribuer, c'est apporter des idées applicables plutôt que des slogans. C'est rassembler autour du bien commun plutôt que diviser pour mobiliser. C'est s'engager sur des résultats mesurables plutôt que sur des promesses invérifiables. Et c'est accepter de créditer ce qui marche, même lorsque cela vient d'un adversaire, tout en corrigeant sans relâche ce qui échoue.",
            "Ce positionnement n'est ni une posture de neutralité ni une complaisance envers les pouvoirs en place. Nous savons être fermes quand l'intérêt général l'exige. Mais notre fermeté s'exprime par des propositions solides, pas par la surenchère verbale. Nous préférons convaincre plutôt que vaincre, et démontrer plutôt que dénoncer."
          ]
        },
        {
          number: "III",
          title: "Le cap institutionnel",
          subtitle: "Notre projet : la 4ᵉ République",
          paragraphs: [
            "Au-delà des politiques publiques, notre ambition est institutionnelle. Nous portons le projet d'une 4ᵉ République : une refondation du contrat entre l'État et les citoyens, pour des institutions plus justes, plus stables et plus proches du terrain."
          ],
          principles: [
            {
              title: "L'équilibre des pouvoirs",
              text: "Une démocratie vivante suppose des contre-pouvoirs réels et une séparation claire des rôles. Nous défendons des institutions où l'exécutif, le législatif et le judiciaire se contrôlent mutuellement."
            },
            {
              title: "La démocratie de proximité",
              text: "La République doit se vivre partout, et pas seulement dans la capitale. Nous voulons rapprocher la décision des citoyens et des territoires."
            },
            {
              title: "La redevabilité",
              text: "Ceux qui exercent une responsabilité publique doivent rendre compte de leurs résultats devant ceux qui les ont mandatés. Un mandat n'est pas un chèque en blanc."
            }
          ]
        },
        {
          number: "IV",
          title: "Le programme",
          subtitle: "Nos priorités pour le pays",
          priorities: [
            {
              title: "Le calendrier scolaire",
              subtitle: "Notre proposition phare",
              text: "Adapter le rythme de l'année aux réalités du pays. Repenser le calendrier pour l'aligner sur les réalités climatiques régionales et sur le bien-être de ceux qui font l'école."
            },
            {
              title: "La vie chère",
              subtitle: "Redonner du pouvoir d'achat, sans démagogie",
              text: "Cibler les produits de première nécessité, renforcer la transparence des prix, soutenir la production locale."
            },
            {
              title: "Les infrastructures et la sécurité routière",
              subtitle: "Un pays désenclavé, des routes qui ne tuent plus",
              text: "La sécurité routière au rang de priorité: signalisation, entretien, contrôle et sensibilisation."
            },
            {
              title: "La santé",
              subtitle: "Des soins de proximité pour tous",
              text: "Un maillage sanitaire de proximité, une meilleure répartition des personnels et des moyens, et une attention particulière à la prévention."
            },
            {
              title: "L'emploi des jeunes",
              subtitle: "Transformer une force démographique en moteur économique",
              text: "Rapprocher la formation des besoins réels de l'économie, soutenir l'entrepreneuriat et l'initiative locale."
            },
            {
              title: "La bonne gouvernance",
              subtitle: "Faire reculer la corruption, protéger l'argent public",
              text: "Transparence des marchés publics, renforcement des contrôles indépendants et protection de ceux qui signalent les abus."
            },
            {
              title: "Les femmes et l'égalité des chances",
              subtitle: "Libérer la moitié des forces du pays",
              text: "Accès équitable à l'éducation, au crédit et à l'entrepreneuriat, meilleure représentation dans les responsabilités."
            },
            {
              title: "La décentralisation",
              subtitle: "Développer toutes les régions, pas seulement la capitale",
              text: "Une décentralisation réelle, qui donne aux collectivités les compétences et les moyens d'agir au plus près des besoins."
            }
          ]
        },
        {
          number: "V",
          title: "L'ambition régionale",
          subtitle: "La Côte d'Ivoire dans son continent",
          paragraphs: [
            "Notre parti porte le mot « africaine » dans son nom, et ce n'est pas un hasard. L'avenir de la Côte d'Ivoire ne se joue pas seulement à l'intérieur de ses frontières : il se joue aussi dans sa capacité à peser dans la sous-région et sur le continent.",
            "Nous croyons à une intégration africaine concrète, qui profite d'abord aux citoyens : un espace d'échanges élargi pour nos producteurs et nos entreprises, une coopération renforcée entre voisins, et une voix ivoirienne respectée parce qu'elle est constructive.",
            "Une Côte d'Ivoire forte dans une Afrique qui coopère : voilà l'horizon que nous traçons."
          ]
        },
        {
          number: "VI",
          title: "Notre méthode",
          subtitle: "De l'idée à l'action",
          steps: [
            { number: "1", title: "Écouter", text: "Partir du vécu réel des Ivoiriens plutôt que des idées reçues." },
            { number: "2", title: "Analyser", text: "Étudier les faits et les données disponibles, comprendre les causes avant de proposer des remèdes." },
            { number: "3", title: "Proposer", text: "Formuler des solutions applicables, chiffrées lorsque c'est possible." },
            { number: "4", title: "Rendre compte", text: "Mesurer les effets des mesures portées et publier les résultats." }
          ]
        },
        {
          number: "VII",
          title: "Nos valeurs",
          subtitle: "Ce qui nous guide",
          values: [
            { number: "1", title: "Intégrité", text: "La transparence et la lutte contre la corruption comme boussole de toute action publique." },
            { number: "2", title: "Solidarité", text: "Une nation où personne n'est laissé de côté, des plus jeunes aux aînés." },
            { number: "3", title: "Compétence", text: "Des propositions étayées, chiffrées lorsque c'est possible, et confrontées au réel." },
            { number: "4", title: "Patriotisme", text: "L'intérêt de la nation placé avant tout calcul partisan ou personnel." }
          ]
        },
        {
          number: "VIII",
          title: "Notre gouvernance",
          subtitle: "Un parti à l'image de son projet",
          paragraphs: [
            "Nous ne demandons pas au pays ce que nous ne nous appliquons pas à nous-mêmes. L'exigence de clarté, d'efficacité et de redevabilité commence à l'intérieur du parti.",
            "Notre direction est volontairement resserrée : chaque poste correspond à une fonction réellement utile, sans doublon honorifique."
          ]
        },
        {
          number: "IX",
          title: "Financer nos propositions",
          subtitle: "Le sérieux avant la promesse",
          paragraphs: [
            "Trop de programmes politiques additionnent les promesses sans jamais dire comment elles seront financées. Nous refusons cette facilité.",
            "Notre règle est simple. Chaque mesure d'ampleur que nous portons est accompagnée d'une estimation de son coût, d'une réflexion sur son financement, et d'un calendrier réaliste de mise en œuvre.",
            "Ce sérieux n'est pas de la tiédeur : c'est le respect que nous devons aux citoyens."
          ]
        },
        {
          number: "X",
          title: "Nos engagements",
          subtitle: "Ce à quoi nous nous tenons",
          commitments: [
            { number: "1", title: "Dire la vérité", text: "Nous ne promettrons jamais ce que nous savons ne pas pouvoir tenir." },
            { number: "2", title: "Proposer avant de critiquer", text: "Aucune dénonciation sans solution de rechange concrète." },
            { number: "3", title: "Rendre des comptes", text: "Chaque proposition portée sera évaluée sur des indicateurs publics et vérifiables." },
            { number: "4", title: "Rester ouverts", text: "Nous saluerons ce qui fonctionne, même venu d'ailleurs, et débattrons sans invective." },
            { number: "5", title: "Servir, non nous servir", text: "L'exemplarité et la sobriété comme règle, à tous les niveaux de responsabilité." }
          ]
        }
      ],
      callToAction: {
        title: "Notre appel",
        subtitle: "Rejoignez le mouvement",
        text: "Ce manifeste n'appartient à personne en particulier. Il appartient à tous ceux qui refusent de choisir entre l'aveuglement et le désespoir, et qui préfèrent l'action utile.",
        appeal: "À la jeunesse qui doute de son avenir, aux familles qui comptent chaque dépense, aux femmes qui portent le pays sans toujours être entendues, aux travailleurs des villes et des campagnes, aux aînés qui ont bâti ce que nous sommes : nous disons que votre place est ici.",
        closing: "Ensemble, faisons le choix d'une Côte d'Ivoire de la contribution.",
        motto: "Une nation, un avenir."
      },
      conclusion: {
        title: "Conclusion",
        lines: [
          "Un État recentré.",
          "Des territoires puissants.",
          "Des citoyens responsables."
        ],
        final: "C'est ainsi que se reconstruit la Nation."
      }
    },
    visionPage: {
      title: "Notre vision de l'État",
      sections: [
        {
          title: "Un État stratège",
          paragraphs: [
            "L'État définit la vision, garantit la justice, assure la sécurité, protège l'intérêt général.",
            "Il ne s'éparpille plus. Il arbitre, oriente et régule."
          ]
        },
        {
          title: "Gouvernance éthique",
          paragraphs: [
            "Responsabilité personnelle des dirigeants.",
            "Transparence des décisions.",
            "Indépendance réelle de la justice.",
            "La confiance se mérite."
          ]
        },
        {
          title: "Décentralisation politique",
          paragraphs: [
            "Ce qui peut être décidé localement doit l'être localement.",
            "Les territoires disposent de compétences claires, de ressources propres et d'une capacité de planification autonome."
          ]
        }
      ]
    },
    territoriesPage: {
      title: "Territoires & Souveraineté Économique",
      localTag: "Local : Côte d'Ivoire",
      sections: [
        {
          title: "La provincialité économique",
          paragraphs: [
            "Chaque territoire devient un centre de production et d'investissement.",
            "Les provinces ne sont plus des guichets. Elles deviennent des moteurs."
          ]
        },
        {
          title: "Les corporations territoriales",
          paragraphs: [
            "Des entreprises publiques locales, performantes et responsables, opérant dans les secteurs stratégiques.",
            "Elles créent de l'emploi. Elles génèrent des revenus. Elles réinvestissent localement."
          ]
        },
        {
          title: "Une fédération économique cohérente",
          paragraphs: [
            "La province est un centre d'investissement.",
            "La ville est un incubateur d'innovation.",
            "La nation est une architecture cohérente."
          ]
        }
      ]
    },
    projectsPage: {
      title: "Sécurité, Jeunesse, Numérique",
      sections: [
        {
          title: "Sécurité & justice",
          points: [
            "Autorité légitime.",
            "Présence territoriale.",
            "Justice rapide, indépendante et accessible."
          ]
        },
        {
          title: "Jeunesse & culture",
          points: [
            "Des parcours clairs.",
            "Une formation valorisée.",
            "Une culture comme force économique et identitaire."
          ]
        },
        {
          title: "Numérique & souveraineté",
          points: [
            "Services publics accessibles.",
            "Procédures simplifiées.",
            "Maîtrise des données et des infrastructures."
          ]
        }
      ]
    },
    aboutPage: {
      title: "À propos de l'ADA",
      paragraphs: [
        "L'Alliance Démocratique Africaine est un mouvement politique national.",
        "Elle porte une ambition claire : refonder l'État, libérer les territoires et projeter la Nation dans le temps long.",
        "L'ADA ne promet pas des miracles. Elle propose une architecture."
      ],
      values: {
        title: "Nos valeurs",
        items: [
          { title: "Responsabilité", description: "Chaque action engage notre nom et notre parole." },
          { title: "Contribution", description: "Nous venons avec des solutions, pas seulement des critiques." },
          { title: "Progression", description: "Avancer sûrement, gagner la confiance avant de gagner le pouvoir." }
        ]
      },
      contributors: {
        title: "Les contributeurs",
        description: "L'ADA rassemble des citoyens de toutes conditions : modestes et aisés, chrétiens et musulmans, citadins et ruraux, hommes et femmes, jeunes et anciens. Cette diversité est notre force."
      }
    },
    footer: {
      tagline: "Une Nation. Des territoires forts. Un avenir souverain.",
      links: "Liens rapides",
      contact: "Contact",
      social: "Suivez-nous",
      rights: "Tous droits réservés.",
      localTag: "Présence locale : Côte d'Ivoire"
    },
    joinForm: {
      title: "Rejoindre",
      subtitle: "Participez à la construction d'une nouvelle vision politique.",
      paths: {
        inform: {
          title: "Être informé",
          description: "Recevez nos actualités et nos propositions par email."
        },
        contribute: {
          title: "Devenir contributeur",
          description: "Participez à l'élaboration de nos propositions et à nos actions terrain."
        },
        donate: {
          title: "Micro-don",
          description: "Soutenez le mouvement. Reporting trimestriel des dons."
        }
      },
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      city: "Ville",
      country: "Pays",
      message: "Message (optionnel)",
      submit: "Rejoindre ADA",
      success: "Merci pour votre engagement. Nous vous contacterons bientôt."
    }
  },
  en: {
    nav: {
      home: "Home",
      ada: "ADA",
      posture: "Our Posture",
      approach: "Approach",
      proposals: "Proposals",
      news: "News",
      join: "Join",
      microdon: "Donate",
      manifesto: "The Manifesto",
      vision: "Our Vision",
      territories: "Territories",
      projects: "Security, Youth, Digital",
      about: "About"
    },
  pt: {
    nav: {
      home: "Início",
      ada: "ADA",
      posture: "Nossa Postura",
      approach: "Abordagem",
      proposals: "Propostas",
      news: "Notícias",
      join: "Aderir",
      microdon: "Doação",
      manifesto: "O Manifesto",
      vision: "Nossa Visão",
      territories: "Territórios",
      projects: "Segurança, Juventude, Digital",
      about: "Sobre"
    },
    hero: {
      title: "Uma Nação. Territórios fortes. Um futuro soberano.",
      subtitle: "Refundar o Estado. Libertar os territórios. Construir uma República económica descentralizada.",
      questions: [
        "Para onde queremos ir juntos?",
        "O que transmitimos aos nossos filhos?",
        "Como construir um Estado que funcione?",
        "Como criar riqueza nos nossos territórios?",
        "Qual é o lugar para a nossa juventude?",
        "Como reconciliar tradição e modernidade?"
      ]
    },
    posture: {
      teaser: {
        title: "Nossa Postura",
        text: "Construtiva. Contributiva. Avançando firmemente.",
        link: "Ler mais"
      }
    },
    constat: {
      title: "A situação",
      paragraphs: [
        "A África ganhou estabilidade. Mas os nossos modelos de governação atingiram os seus limites.",
        "Centralização excessiva, poder distante, fadiga democrática, juventude em espera, territórios subexplorados.",
        "Os nossos países não precisam de remendos. Precisam de um novo contrato político."
      ]
    },
    vision: {
      title: "A visão ADA",
      intro: "A Aliança Democrática Africana propõe uma refundação lúcida e assumida:",
      points: [
        "Um Estado estratégico, recentrado nas suas missões essenciais.",
        "Territórios autónomos, produtores de riqueza.",
        "Cidadãos ativos, responsáveis e protegidos."
      ],
      conclusion: "A soberania já não se decreta a partir do topo. Constrói-se, território por território."
    },
    pillars: {
      title: "Os três pilares",
      items: [
        {
          title: "Refundar o Estado",
          description: "Clarificar papéis, restaurar a autoridade legítima, garantir a justiça."
        },
        {
          title: "Libertar os territórios",
          description: "Dar às províncias e cidades os meios para produzir, investir e planificar."
        },
        {
          title: "Projetar a Nação",
          description: "Segurança, juventude, digital: preparar o futuro sem dependência."
        }
      ]
    },
    manifesto: {
      title: "O Manifesto",
      intro: "O Manifesto ADA é um texto fundador. Apresenta uma visão coerente, estruturada, pensada para o longo prazo.",
      cta: "Ler o Manifesto"
    },
    territories: {
      title: "Os territórios",
      lines: [
        "Cada território conta.",
        "Cada território produz.",
        "Cada território contribui."
      ],
      conclusion: "Uma federação económica coerente, construída a partir da base."
    },
    cta: {
      discover: "Descobrir a visão",
      join: "Aderir ao movimento",
      contribute: "Contribuir",
      readProposals: "Ler as nossas propostas"
    },
    footer: {
      tagline: "Uma Nação. Territórios fortes. Um futuro soberano.",
      links: "Links rápidos",
      contact: "Contacto",
      social: "Siga-nos",
      rights: "Todos os direitos reservados.",
      localTag: "Presença local: Costa do Marfim"
    },
    joinForm: {
      title: "Aderir ao movimento",
      subtitle: "Participe na construção de uma nova visão política.",
      paths: {
        inform: {
          title: "Manter-se informado",
          description: "Receba as nossas notícias e propostas por email."
        },
        contribute: {
          title: "Tornar-se contribuidor",
          description: "Participe na elaboração das nossas propostas e ações no terreno."
        },
        donate: {
          title: "Micro-doação",
          description: "Apoie o movimento. Relatório trimestral de doações."
        }
      },
      firstName: "Nome próprio",
      lastName: "Apelido",
      email: "Email",
      phone: "Telefone",
      city: "Cidade",
      country: "País",
      message: "Mensagem (opcional)",
      submit: "Aderir à ADA",
      success: "Obrigado pelo seu compromisso. Entraremos em contacto em breve."
    }
  },
    hero: {
      title: "One Nation. Strong territories. A sovereign future.",
      subtitle: "Rebuild the State. Free the territories. Build a decentralized economic Republic.",
      questions: [
        "Where do we want to go together?",
        "What do we pass on to our children?",
        "How do we build a state that works?",
        "How do we create wealth in our territories?",
        "What place for our youth?",
        "How do we reconcile tradition and modernity?"
      ]
    },
    posture: {
      teaser: {
        title: "Our Posture",
        text: "Constructive. Contributive. Steadily moving.",
        link: "Read more"
      }
    },
    constat: {
      title: "The situation",
      paragraphs: [
        "Africa has gained stability. But our governance models have reached their limits.",
        "Excessive centralization, distant power, democratic fatigue, youth in waiting, underexploited territories.",
        "Our countries don't need patching. They need a new political contract."
      ]
    },
    vision: {
      title: "The ADA vision",
      intro: "The African Democratic Alliance proposes a lucid and assumed refoundation:",
      points: [
        "A strategic State, refocused on its essential missions.",
        "Autonomous territories, producers of wealth.",
        "Active citizens, responsible and protected."
      ],
      conclusion: "Sovereignty is no longer decreed from the top. It is built, territory by territory."
    },
    pillars: {
      title: "The three pillars",
      items: [
        {
          title: "Rebuild the State",
          description: "Clarify roles, restore legitimate authority, guarantee justice."
        },
        {
          title: "Free the territories",
          description: "Give provinces and cities the means to produce, invest and plan."
        },
        {
          title: "Project the Nation",
          description: "Security, youth, digital: prepare the future without dependence."
        }
      ]
    },
    manifesto: {
      title: "The Manifesto",
      intro: "The ADA Manifesto is a founding text. It presents a coherent, structured vision, designed for the long term.",
      cta: "Read the Manifesto"
    },
    territories: {
      title: "The territories",
      lines: [
        "Every territory counts.",
        "Every territory produces.",
        "Every territory contributes."
      ],
      conclusion: "A coherent economic federation, built from the ground up."
    },
    cta: {
      discover: "Discover the vision",
      join: "Join the movement",
      contribute: "Contribute",
      readProposals: "Read our proposals"
    },
    footer: {
      tagline: "One Nation. Strong territories. A sovereign future.",
      links: "Quick links",
      contact: "Contact",
      social: "Follow us",
      rights: "All rights reserved.",
      localTag: "Local presence: Côte d'Ivoire"
    },
    joinForm: {
      title: "Join the movement",
      subtitle: "Participate in building a new political vision.",
      paths: {
        inform: {
          title: "Stay informed",
          description: "Receive our news and proposals by email."
        },
        contribute: {
          title: "Become a contributor",
          description: "Participate in developing our proposals and field actions."
        },
        donate: {
          title: "Micro-donation",
          description: "Support the movement. Quarterly donation reporting."
        }
      },
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      city: "City",
      country: "Country",
      message: "Message (optional)",
      submit: "Join ADA",
      success: "Thank you for your commitment. We will contact you soon."
    }
  }
};

// Regions/Provinces data for interactive map (Local: Côte d'Ivoire)
export const regions = [
  { id: "abidjan", name: "Abidjan", type: "district", x: 42, y: 78, color: "#5B2D8E", icon: "building" },
  { id: "yamoussoukro", name: "Yamoussoukro", type: "district", x: 38, y: 58, color: "#F7C948", icon: "landmark" },
  { id: "bouake", name: "Bouaké", type: "city", x: 42, y: 45, color: "#0D9488", icon: "factory" },
  { id: "korhogo", name: "Korhogo", type: "city", x: 38, y: 18, color: "#5B2D8E", icon: "mountain" },
  { id: "man", name: "Man", type: "city", x: 18, y: 42, color: "#F7C948", icon: "trees" },
  { id: "sanpedro", name: "San-Pédro", type: "city", x: 22, y: 88, color: "#0D9488", icon: "ship" },
  { id: "daloa", name: "Daloa", type: "city", x: 28, y: 52, color: "#5B2D8E", icon: "wheat" },
  { id: "gagnoa", name: "Gagnoa", type: "city", x: 30, y: 62, color: "#F7C948", icon: "leaf" },
  { id: "divo", name: "Divo", type: "city", x: 35, y: 70, color: "#0D9488", icon: "droplet" },
  { id: "bondoukou", name: "Bondoukou", type: "city", x: 62, y: 38, color: "#5B2D8E", icon: "store" },
  { id: "odienne", name: "Odienné", type: "city", x: 15, y: 20, color: "#F7C948", icon: "sun" },
  { id: "ferkessedougou", name: "Ferké", type: "city", x: 48, y: 22, color: "#0D9488", icon: "train" }
];

export const socialLinks = [
  { name: "Facebook", url: "#" },
  { name: "Twitter", url: "#" },
  { name: "Instagram", url: "#" },
  { name: "LinkedIn", url: "#" }
];

// Notre Posture page content
export const postureContent = {
  pt: {
    hero: {
      title: "Construtiva. Contributiva. Avançando firmemente.",
      subtitle: "Não estamos aqui para assustar. Estamos aqui para melhorar — e para ganhar, progressivamente, com certeza."
    },
    concrete: {
      title: "O que significa, concretamente",
      items: [
        "Dizer a verdade sem histeria.",
        "Apoiar o que é justo, venha de onde vier.",
        "Recusar o que é perigoso, ineficaz ou injusto — e propor melhor."
      ]
    },
    method: {
      title: "O nosso método",
      verbs: [
        { word: "Observar", description: "Compreender a realidade antes de a transformar." },
        { word: "Questionar", description: "Fazer as perguntas certas, sem tabu." },
        { word: "Propor", description: "Vir com soluções, mecanismos, testes de terreno." },
        { word: "Agir", description: "Passar à ação, medir, ajustar." }
      ],
      conclusion: "A política útil começa com a realidade — e termina com resultados."
    },
    trajectory: {
      title: "A nossa trajetória",
      steps: [
        { number: "1", title: "Convencer", description: "Terreno, comunidades, soluções testadas." },
        { number: "2", title: "Ganhar lugares", description: "Municípios, regiões, assembleias." },
        { number: "3", title: "Ganhar eleições", description: "Pela confiança, não pelo medo." }
      ],
      conclusion: "Não reclamamos o poder: merecemo-lo. E construímo-lo."
    },
    signature: {
      punchline: "Calmos no tom. Intransigentes no essencial."
    }
  },
  fr: {
    hero: {
      title: "Constructive. Contributive.",
      subtitle: "Nous ne sommes pas là pour effrayer. Nous sommes là pour améliorer — et pour gagner, progressivement, sûrement."
    },
    concrete: {
      title: "Ce que ça veut dire, concrètement",
      items: [
        "Dire la vérité sans hystérie.",
        "Soutenir ce qui est juste, d'où que ça vienne.",
        "Refuser ce qui est dangereux, inefficace ou injuste — et proposer mieux."
      ]
    },
    method: {
      title: "Notre méthode",
      verbs: [
        { word: "Observer", description: "Comprendre le réel avant de le transformer." },
        { word: "Questionner", description: "Poser les bonnes questions, sans tabou." },
        { word: "Proposer", description: "Venir avec des solutions, des mécanismes, des tests terrain." },
        { word: "Agir", description: "Passer à l'action, mesurer, ajuster." }
      ],
      conclusion: "La politique utile commence par le réel — et se termine par des résultats."
    },
    trajectory: {
      title: "Notre trajectoire",
      steps: [
        { number: "1", title: "Convaincre", description: "Terrain, communautés, solutions testées." },
        { number: "2", title: "Gagner des sièges", description: "Communes, régions, assemblées." },
        { number: "3", title: "Gagner les élections", description: "Sur la confiance, pas sur la peur." }
      ],
      conclusion: "On ne réclame pas le pouvoir : on le mérite. Et on le construit."
    },
    signature: {
      punchline: "Calmes dans le ton. Intransigeants sur l'essentiel."
    }
  },
  en: {
    hero: {
      title: "Constructive. Contributive. Steadily moving.",
      subtitle: "We are not here to frighten. We are here to improve — and to win, progressively, surely."
    },
    concrete: {
      title: "What it means, concretely",
      items: [
        "Speak the truth without hysteria.",
        "Support what is right, wherever it comes from.",
        "Reject what is dangerous, ineffective or unjust — and propose better."
      ]
    },
    method: {
      title: "Our method",
      verbs: [
        { word: "Observe", description: "Understand reality before transforming it." },
        { word: "Question", description: "Ask the right questions, without taboo." },
        { word: "Propose", description: "Come with solutions, mechanisms, field tests." },
        { word: "Act", description: "Take action, measure, adjust." }
      ],
      conclusion: "Useful politics starts with reality — and ends with results."
    },
    trajectory: {
      title: "Our trajectory",
      steps: [
        { number: "1", title: "Convince", description: "Field work, communities, tested solutions." },
        { number: "2", title: "Win seats", description: "Municipalities, regions, assemblies." },
        { number: "3", title: "Win elections", description: "On trust, not on fear." }
      ],
      conclusion: "We don't demand power: we earn it. And we build it."
    },
    signature: {
      punchline: "Calm in tone. Uncompromising on the essentials."
    }
  }
};

// Approach page content (Observer/Questionner/Proposer/Agir)
export const approachContent = {
  pt: {
    title: "A nossa abordagem",
    subtitle: "Um método rigoroso para uma política útil",
    verbs: [
      {
        word: "Observar",
        description: "Compreender antes de agir. Ouvir os territórios, os cidadãos, os especialistas. Recolher dados, analisar situações, identificar os verdadeiros problemas.",
        icon: "eye"
      },
      {
        word: "Questionar",
        description: "Fazer as perguntas certas, mesmo quando incomodam. Desafiar pressupostos, hábitos, interesses estabelecidos. Abrir o debate.",
        icon: "help-circle"
      },
      {
        word: "Propor",
        description: "Vir com soluções concretas, quantificadas, testáveis. Não slogans, mas mecanismos. Não promessas, mas planos.",
        icon: "lightbulb"
      },
      {
        word: "Agir",
        description: "Passar à ação onde for possível. Experimentar, medir, ajustar. Provar pelos factos que as nossas propostas funcionam.",
        icon: "play"
      }
    ],
    constructive: {
      title: "Postura construtiva e contributiva",
      items: [
        "Criticamos quando necessário.",
        "Apoiamos o que é justo, mesmo que não venha de nós.",
        "Vimos com soluções, mecanismos, testes de terreno.",
        "Ganhamos a confiança antes de ganhar as eleições."
      ]
    }
  },
  fr: {
    title: "Notre approche",
    subtitle: "Une méthode rigoureuse pour une politique utile",
    verbs: [
      {
        word: "Observer",
        description: "Comprendre avant d'agir. Écouter les territoires, les citoyens, les experts. Collecter les données, analyser les situations, identifier les vrais problèmes.",
        icon: "eye"
      },
      {
        word: "Questionner",
        description: "Poser les bonnes questions, même quand elles dérangent. Remettre en cause les évidences, les habitudes, les intérêts établis. Ouvrir le débat.",
        icon: "help-circle"
      },
      {
        word: "Proposer",
        description: "Venir avec des solutions concrètes, chiffrées, testables. Pas des slogans, mais des mécanismes. Pas des promesses, mais des plans.",
        icon: "lightbulb"
      },
      {
        word: "Agir",
        description: "Passer à l'action là où c'est possible. Expérimenter, mesurer, ajuster. Prouver par les faits que nos propositions fonctionnent.",
        icon: "play"
      }
    ],
    constructive: {
      title: "Posture constructive & contributive",
      items: [
        "Nous critiquons quand il le faut.",
        "Nous soutenons ce qui est juste, même si ça ne vient pas de nous.",
        "Nous venons avec des solutions, des mécanismes, des tests terrain.",
        "Nous gagnons la confiance avant de gagner les élections."
      ]
    }
  },
  en: {
    title: "Our approach",
    subtitle: "A rigorous method for useful politics",
    verbs: [
      {
        word: "Observe",
        description: "Understand before acting. Listen to territories, citizens, experts. Collect data, analyze situations, identify real problems.",
        icon: "eye"
      },
      {
        word: "Question",
        description: "Ask the right questions, even when they disturb. Challenge assumptions, habits, established interests. Open the debate.",
        icon: "help-circle"
      },
      {
        word: "Propose",
        description: "Come with concrete, quantified, testable solutions. Not slogans, but mechanisms. Not promises, but plans.",
        icon: "lightbulb"
      },
      {
        word: "Act",
        description: "Take action where possible. Experiment, measure, adjust. Prove by facts that our proposals work.",
        icon: "play"
      }
    ],
    constructive: {
      title: "Constructive & contributive posture",
      items: [
        "We criticize when necessary.",
        "We support what is right, even if it doesn't come from us.",
        "We come with solutions, mechanisms, field tests.",
        "We win trust before winning elections."
      ]
    }
  }
};

// Proposals/Axes content
export const proposalsContent = {
  pt: {
    title: "As nossas propostas",
    subtitle: "Três transformações para uma nação soberana",
    axes: [
      {
        id: "institutional",
        title: "Transformação institucional",
        description: "Refundar o Estado para servir verdadeiramente os cidadãos.",
        proposals: [
          { 
            title: "Criação de províncias na Costa do Marfim",
            tag: "Proximidade",
            description: "Propomos a criação de novas entidades territoriais, dotadas de prerrogativas políticas e económicas e câmaras legislativas próprias.",
            fullText: "O entusiasmo dos visitantes estrangeiros pela capital económica, Abidjan, não desvanece; consideram a cidade bonita, com infraestruturas sólidas. Estes mesmos visitantes ignoram frequentemente que a apenas uma hora de Abidjan, a eletricidade é escassa, as estradas secundárias se deterioram, e as infraestruturas de saúde — com 1 médico para 6.000 pessoas! — são inadequadas.\n\nPropomos a criação de novas entidades territoriais, dotadas de prerrogativas políticas e económicas e câmaras legislativas próprias, cuja missão será assegurar um desenvolvimento económico e social harmonioso em toda a Costa do Marfim."
          },
          { 
            title: "Transformação do Senado",
            tag: "Legitimidade",
            description: "Um Senado eleito inteiramente como câmara representativa dos territórios seria a continuação lógica do estabelecimento de províncias.",
            fullText: "A decisão de estabelecer um Senado resultou da visão de que se pode beneficiar da experiência de sábios experientes. No entanto, pode-se considerar — como em muitos países — que o Senado é acima de tudo uma câmara representativa dos territórios.\n\nUm Senado eleito inteiramente nesta base seria a continuação lógica do estabelecimento de províncias e a sua legitimidade poderia ser maior."
          },
          { 
            title: "Painel cidadão",
            tag: "Democracia participativa",
            description: "Reforçar o controlo efetivo da ação governamental pela sociedade civil, através de um procedimento de democracia participativa consagrado na Constituição.",
            fullText: "O objetivo é reforçar o controlo efetivo da ação do governo e do parlamento pela sociedade civil, através de um procedimento de democracia participativa consagrado na Constituição: o painel cidadão.\n\nEste painel deve ser representativo dos diferentes componentes da sociedade e renovável a cada dois anos."
          }
        ]
      },
      {
        id: "economic",
        title: "Transformação económica",
        description: "Criar riqueza em cada território.",
        proposals: [
          { 
            title: "Agência nacional de planeamento",
            tag: "Desenvolvimento inclusivo",
            description: "Uma grande agência para colmatar as disparidades de desenvolvimento entre regiões, com orçamento operacional e capaz de coordenar a implantação de infraestruturas essenciais.",
            fullText: "Acreditamos ser urgente criar tal agência, com orçamento operacional e capaz de coordenar a implantação de infraestruturas essenciais — escolas, saúde, estradas, conectividade internet — mas também de apoiar a estratégia económica de cada província.\n\nEsta agência teria um triplo papel de recomendação, execução e avaliação."
          },
          { 
            title: "Cadeias de valor setoriais",
            tag: "Trampolim para PME",
            description: "Continuar e reforçar ações para apoiar o desenvolvimento das PME marfinenses através de estratégia setorial direcionada.",
            fullText: "Propomos continuar e reforçar ações para apoiar o desenvolvimento das PME marfinenses através de uma estratégia setorial.\n\nPara setores-chave — agroprocessamento, novas tecnologias, transporte e logística — identificaríamos profissões onde a oferta de serviços é mais fraca para reforçar competências onde necessário.\n\nO objetivo seria cadeias de valor completas permitindo às PME marfinenses tornarem-se fornecedores mais competitivos de grandes grupos."
          }
        ]
      },
      {
        id: "social",
        title: "Transformação social",
        description: "Investir no capital humano.",
        proposals: [
          { 
            title: "Casas das oportunidades",
            tag: "Oportunidades",
            description: "Uma rede nacional de pequenos centros reunindo infraestruturas de conectividade internet para aquisição de competências digitais e apoio económico.",
            fullText: "Esta rede nacional seria composta por pequenos centros reunindo infraestruturas de conectividade internet com dois objetivos principais:\n\n(1) aquisição pelas crianças de competências em novas tecnologias\n(2) apoio aos adultos no desenvolvimento de atividades económicas locais.\n\nA longo prazo, imaginamos que estas casas poderiam também constituir a espinha dorsal de uma rede nacional de serviços a indivíduos/empreendedores."
          },
          { 
            title: "Caravana da memória",
            tag: "Memória",
            description: "Uma viagem para lembrar quem somos e definir o que queremos tornar-nos, indo de aldeia em aldeia recolher elementos da memória marfinense.",
            fullText: "Uma viagem para lembrar quem somos e definir o que queremos tornar-nos. Tal seria a missão da nossa caravana, indo de aldeia em aldeia recolher todos os elementos constitutivos da memória marfinense.\n\nLembrar, sem nostalgia. Lembrar para reconstruir."
          }
        ]
      }
    ],
    cta: {
      share: "Partilhar",
      comment: "Comentar",
      contribute: "Eu contribuo",
      readMore: "Ler mais",
      collapse: "Recolher"
    },
    sections: {
      diagnostic: "Diagnóstico",
      proposition: "Proposta",
      implementation: "Implementação",
      impact: "Impacto esperado"
    }
  },
  fr: {
    title: "Nos propositions",
    subtitle: "Trois transformations pour une nation souveraine",
    axes: [
      {
        id: "institutional",
        title: "Transformation institutionnelle",
        description: "Refonder l'État pour qu'il serve vraiment les citoyens.",
        proposals: [
          { 
            title: "La création de provinces en Côte d'Ivoire",
            tag: "Proximité",
            description: "Nous proposons la création de nouvelles entités territoriales, dotées de prérogatives politiques et économiques, et de chambres législatives propres, dont la mission sera d'assurer un développement économique et social harmonieux de la Côte d'Ivoire dans son ensemble.",
            fullText: "L'enthousiasme des visiteurs étrangers pour la capitale économique, Abidjan, ne se dément pas ; ils estiment que la ville est belle, dotée d'infrastructures solides, et symbolise parfaitement le développement économique à l'africaine. Ces mêmes visiteurs ignorent souvent qu'à une heure seulement d'Abidjan, l'électricité se fait rare, que les voies d'accès secondaires dans de nombreuses zones rurales se détériorent, que le réseau d'infrastructures éducatives ou sanitaires - avec 1 médecin pour 6000 personnes ! - n'est pas à la hauteur des besoins.\n\nNous proposons la création de nouvelles entités territoriales, dotées de prérogatives politiques et économiques, et de chambres législatives propres, dont la mission sera d'assurer un développement économique et social harmonieux de la Côte d'Ivoire dans son ensemble. Il s'agit de mettre en valeur les atouts de chaque région, en créant des synergies pour que chacune trouve sa place dans le paysage économique."
          },
          { 
            title: "La transformation du Sénat",
            tag: "Légitimité",
            description: "Un Sénat élu en totalité comme chambre représentative des territoires serait la continuation logique de l'instauration de provinces et sa légitimité pourrait être plus grande.",
            fullText: "La décision d'instaurer un Sénat en Côte d'Ivoire résultait de la vision selon laquelle on peut utilement bénéficier de l'expérience de sages expérimentés. On peut cependant s'inspirer d'autres approches, et considérer - ce qui est le cas dans beaucoup de pays - que le Sénat est avant tout une chambre représentative des territoires.\n\nC'est une autre forme de sagesse, pas uniquement le résultat de l'âge et de la carrière passée mais aussi de la connaissance du terrain. Un Sénat élu en totalité sur cette base serait la continuation logique de l'instauration de provinces en Côte d'Ivoire et sa légitimité pourrait être plus grande que celle dont il dispose actuellement."
          },
          { 
            title: "Le panel citoyen",
            tag: "Démocratie participative",
            description: "Renforcer le contrôle effectif de l'action du gouvernement et du parlement par la société civile, selon une procédure de démocratie participative entérinée par la Constitution.",
            fullText: "Il s'agit de renforcer le contrôle effectif de l'action du gouvernement et du parlement par la société civile, selon une procédure de démocratie participative qui serait entérinée par la Constitution : le panel citoyen.\n\nCe dernier devrait être représentatif des différentes composantes de la société et renouvelable tous les deux ans. Les personnes désignées pour en faire partie, selon une procédure transparente de tirage au sort au sein de listes répondant aux critères de sélection, auraient le devoir de se réunir pour apprécier l'action gouvernementale sur une année donnée.\n\nLeur évaluation ferait l'objet d'un rapport détaillé, argumenté et rendu public, et remis au Chef du gouvernement. Ce dernier aurait une obligation de réponses aux préoccupations éventuellement soulevées dans le rapport."
          },
          {
            title: "Opposition constructive",
            tag: "Gouvernance éthique",
            subtitle: "Une charte publique des votes : soutenir le juste, amender l'insuffisant, combattre le dangereux",
            hasStructuredFormat: true,
            diagnostic: "La politique est trop souvent perçue comme une opposition automatique ou un soutien aveugle. Cette logique affaiblit la confiance, alimente le cynisme et donne l'impression que les partis cherchent surtout le conflit plutôt que les résultats.",
            proposition: "Nous proposons de formaliser une posture d'opposition constructive et contributive : soutenir les textes utiles, amender ceux qui sont perfectibles, et combattre ceux qui sont dangereux, inefficaces ou injustes. La cohérence doit être visible et vérifiable.",
            implementation: "(1) Publier une \"Charte des votes ADA\" (principe permanent).\n(2) Pour chaque grand texte : produire une fiche publique (1 page) : position (pour/contre/abstention), amendements, raisons, impacts attendus.\n(3) Mettre en place un suivi : \"promesse → vote → résultats\", avec reporting régulier.\n(4) Rendre les propositions d'amendements accessibles au public (pédagogie).",
            impact: "Plus de crédibilité, moins de peur, plus de confiance — et une capacité accrue à gagner des sièges puis des élections par la preuve, pas par le bruit."
          },
          {
            title: "Budget citoyen local",
            tag: "Gouvernance territoriale",
            subtitle: "Flécher une part fixe des budgets communaux/régionaux vers des projets choisis par les citoyens",
            hasStructuredFormat: true,
            diagnostic: "Les citoyens ont souvent le sentiment que les décisions budgétaires sont lointaines, opaques, et déconnectées des besoins réels. Cela nourrit la défiance et affaiblit le contrôle social sur l'action publique.",
            proposition: "Nous proposons qu'une part fixe et encadrée des budgets locaux (par exemple 1% à 3%) soit affectée à des projets définis via une consultation citoyenne simple et transparente. L'objectif : rapprocher la décision du terrain, et produire des résultats visibles.",
            implementation: "(1) Définir un pourcentage cible et un règlement standard (éligibilité, plafonds, calendrier).\n(2) Mettre en place des garde-fous anti-capture : rotation, transparence, audit, publication des décisions.\n(3) Exiger un reporting public trimestriel : état d'avancement, budget consommé, résultats.\n(4) Évaluer chaque année : satisfaction, délais, qualité des travaux.",
            impact: "Confiance renforcée, projets utiles et visibles, meilleure gouvernance locale, et responsabilisation collective."
          }
        ]
      },
      {
        id: "economic",
        title: "Transformation économique",
        description: "Créer de la richesse sur chaque territoire.",
        proposals: [
          { 
            title: "Agence nationale de planification",
            tag: "Développement inclusif",
            description: "Une grande agence pour combler les écarts de développement entre les différentes régions du pays, dotée d'un budget de fonctionnement et capable de coordonner le déploiement d'infrastructures essentielles.",
            fullText: "Nous pensons qu'il est urgent de mettre en place une telle agence, dotée d'un budget de fonctionnement et capable de coordonner le déploiement d'infrastructures essentielles - écoles, infrastructures sanitaires, éducation, voirie, développement urbain, connectivité internet et diffusion des nouvelles technologies - mais aussi d'accompagner la stratégie économique propre à chaque province définie par chacune des chambres provinciales.\n\nCette agence aurait un triple rôle de recommandation, d'exécution et d'évaluation, afin de rééquilibrer et d'ajuster si nécessaire au fur et à mesure."
          },
          { 
            title: "Chaînes de valeurs sectorielles",
            tag: "Tremplin pour les PME",
            description: "Poursuivre et renforcer les actions pour accompagner le développement des PME et PMI ivoiriennes par une stratégie sectorielle ciblée.",
            fullText: "Nous proposons de poursuivre et renforcer certaines actions lancées récemment pour accompagner le développement des PME et PMI ivoiriennes par une stratégie sectorielle.\n\nPour certains secteurs clé - agroprocessing, nouvelles technologies, transport et logistique - on ferait ainsi un état des lieux des chaines de valeur existantes, pour identifier les métiers sur lesquels l'offre de services est plus faible afin de renforcer les compétences là où ce serait nécessaire.\n\nL'objectif serait d'avoir des chaines de valeurs complètes ainsi qu'une dynamique permettant aux PME et PMI ivoiriennes de devenir des fournisseurs plus compétitifs de plus grands groupes."
          },
          { 
            title: "Règles du jeu équitables",
            tag: "Équité",
            description: "Instaurer des règles équitables dans la sphère économique et administrative, permettant à chacun de participer selon ses compétences et son mérite.",
            fullText: "La Côte d'Ivoire reste malheureusement connue pour le niveau élevé de corruption qui caractérise son économie. Nous estimons que cet état de fait résulte entre autres de l'absence d'un dispositif efficace de suivi et de sanctions des comportements anti-concurrentiels, qui ont pour conséquence que certains secteurs sont totalement dominés par quelques entreprises, au détriment des autres acteurs - notamment les plus petits, et, de manière plus générale, au détriment de l'innovation.\n\nNous proposons une réflexion d'ensemble, pour (1) créer un droit de la concurrence effectif, (2) assurer un accès équitable aux marchés publics pour toutes les entreprises, et (3) limiter les comportements visant à réduire la concurrence dans la sphère économique et administrative, tout particulièrement les offres d'achat de places aux concours d'état ou aux examens.\n\nLe critère de préférence nationale pourrait cependant être appliqué de manière sélective de manière à accompagner le développement des PME/PMI ivoiriennes."
          },
          {
            title: "1 000 PME fournisseurs",
            tag: "PME / Emploi",
            subtitle: "Un programme national pour faire émerger des PME capables de fournir l'État et les grands groupes",
            hasStructuredFormat: true,
            diagnostic: "Une partie de l'économie reste dominée par quelques acteurs, tandis que beaucoup de PME restent trop faibles pour accéder aux marchés structurants (normes, qualité, délais, financement, paiement tardif). Cela freine l'emploi et la création de valeur locale.",
            proposition: "Nous proposons un programme \"1 000 PME fournisseurs\" pour structurer des PME ivoiriennes capables de répondre aux besoins de l'État et des grands groupes : qualité, délais, conformité, et compétitivité.",
            implementation: "(1) Créer un label \"PME Fournisseur\" avec critères simples (qualité, comptabilité, délais).\n(2) Organiser des formations ciblées (normes, coûts, logistique, digitalisation).\n(3) Simplifier l'accès aux appels d'offres via une plateforme lisible.\n(4) Instaurer une discipline contractuelle : paiement à temps + sanctions en cas de retard.\n(5) Déployer un mécanisme de garantie/affacturage pour éviter l'asphyxie de trésorerie.",
            impact: "Plus d'emplois, un tissu productif plus solide, plus de concurrence, plus d'innovation, et une économie moins dépendante de quelques acteurs."
          },
          {
            title: "Choc logistique agricole",
            tag: "Agriculture / Coût de la vie",
            subtitle: "Réduire les pertes post-récolte par routes secondaires, stockage et chaîne du froid",
            hasStructuredFormat: true,
            diagnostic: "Une part importante de la production agricole se perd après récolte : routes secondaires dégradées, manque d'entrepôts, absence de chaîne du froid, rupture de transport. Ces pertes augmentent le coût de la vie et réduisent les revenus des producteurs.",
            proposition: "Nous proposons un plan \"Choc logistique agricole\" sur trois ans : pistes rurales prioritaires, micro-hubs de stockage, chambres froides mutualisées, et systèmes de transport plus réguliers.",
            implementation: "(1) Cartographier les zones à forte perte et prioriser 100 à 200 corridors agricoles.\n(2) Déployer des micro-hubs (stockage + froid) gérés en PPP locaux (coopératives + opérateurs).\n(3) Mettre en place une gouvernance par indicateurs : tonnage sauvé, baisse des pertes, hausse de revenus.\n(4) Associer la transformation locale : conditionnement, emballage, normes qualité.",
            impact: "Revenus paysans en hausse, baisse de l'inflation alimentaire, meilleure qualité des produits, et compétitivité accrue à l'export."
          }
        ]
      },
      {
        id: "social",
        title: "Transformation sociale",
        description: "Investir dans le capital humain.",
        proposals: [
          { 
            title: "Maisons des opportunités",
            tag: "Opportunités",
            description: "Un réseau national de petits centres rassemblant des infrastructures de connectivité internet, pour l'acquisition de compétences numériques et l'accompagnement économique.",
            fullText: "Ce réseau national serait composé de petits centres rassemblant en leur sein des infrastructures de connectivité internet - considérées comme des infrastructures essentielles -, avec deux objectifs principaux :\n\n(1) l'acquisition par les enfants, de compétences en matière de nouvelles technologies\n(2) l'accompagnement des adultes dans le développement d'activités économiques locales.\n\nChacune de ces maisons serait sous la direction deux maitres et formateurs experts en nouvelles technologies mais aussi capables d'aider dans la réalisation de documents clé (demande de crédit, business plan…)\n\nA terme, nous imaginons que ces maisons pourraient aussi constituer l'ossature d'un réseau national de services aux personnes/entrepreneurs."
          },
          { 
            title: "Caravane de la mémoire",
            tag: "Mémoire",
            description: "Un voyage pour se rappeler qui nous sommes et définir ce que nous voulons devenir, allant de village en village rassembler les éléments constitutifs de la mémoire ivoirienne.",
            fullText: "Un voyage pour se rappeler qui nous sommes et définir ce que nous voulons devenir. Telle serait la mission de notre caravane, qui irait de village en village rassembler tous les éléments constitutifs de la mémoire ivoirienne.\n\nNous, ivoiriens, nous avons vécu en bonne intelligence… (plus de 70 ethnies)…\n\nNous, ivoiriens… (récit national, prospérité, puis dérives, violences, récit imposé)…\n\nNous ne sommes pas obligés de jouer le rôle qu'on veut nous faire jouer. Ce que nous lisons de nous n'est pas notre vérité.\n\nSe souvenir, sans nostalgie. Se souvenir pour reconstruire."
          },
          {
            title: "Calendrier scolaire bi-saisonnier",
            tag: "Éducation",
            subtitle: "Un calendrier adapté au climat et à la performance scolaire",
            hasStructuredFormat: true,
            diagnostic: "Le rythme scolaire actuel ne tient pas assez compte des réalités climatiques et sanitaires : périodes de forte chaleur, saison des pluies, difficultés de déplacement, pics de maladies saisonnières, fatigue. Résultat : absentéisme, baisse de concentration, inégalités accrues entre zones urbaines et rurales, et perte de temps d'apprentissage réel.",
            proposition: "Nous proposons d'adapter le calendrier scolaire à un pays qui vit essentiellement au rythme de deux saisons, avec un modèle national simple, lisible, et une marge d'ajustement locale encadrée. L'objectif n'est pas de \"moins d'école\", mais une école mieux organisée, plus régulière, plus efficace, et moins pénalisante pour les familles.",
            implementation: "(1) Lancer des pilotes sur 2 à 3 zones climatiques (littoral / centre / nord) pendant une année scolaire complète.\n(2) Fixer un cadre national stable (rentrées, examens, grandes périodes), mais autoriser un ajustement local encadré (±10 à ±15 jours) selon les réalités climatiques.\n(3) Harmoniser les examens et les périodes de révision pour protéger le volume horaire effectif.\n(4) Coupler la réforme à des mesures \"École fraîche\" : ventilation, ombrage, aménagement des horaires lors des pics de chaleur, et critères minimum de confort dans les salles de classe.",
            impact: "Moins d'absentéisme, meilleure santé scolaire, meilleures performances, réduction des inégalités territoriales, et une organisation plus compatible avec la vie des familles et l'économie locale."
          },
          {
            title: "Éveil & Pratique",
            tag: "Éducation",
            subtitle: "Une demi-journée hebdomadaire dédiée aux compétences utiles et à la mise en pratique",
            hasStructuredFormat: true,
            diagnostic: "L'école reste trop souvent vécue comme abstraite : accumulation de savoirs, faible mise en pratique, peu d'ouverture sur la vie réelle, et un déficit d'activités structurantes (sport, projets, civisme, numérique, arts). Cela fragilise l'autonomie, l'esprit critique et l'employabilité future.",
            proposition: "Nous proposons de consacrer une demi-journée par semaine à un programme \"Éveil & Pratique\" : observation, projets en groupe, sport, civisme, arts, numérique, et initiation à l'entrepreneuriat. L'école forme ainsi des enfants en éveil — et des citoyens en action.",
            implementation: "(1) Définir un cadre national léger : thèmes, objectifs, livrables simples.\n(2) Déployer un \"cahier de projets\" standardisé pour les élèves, avec progression par niveaux.\n(3) Mettre en place des partenariats locaux (mairies, artisans, fermes, associations, entreprises) pour accueillir ou intervenir.\n(4) Former un référent par établissement pour coordonner et évaluer la progression.",
            impact: "Une école plus vivante, plus motivante, qui développe des compétences concrètes : collaboration, discipline, initiative, numérique, santé, civisme et confiance en soi."
          },
          {
            title: "Contrat École–Parents",
            tag: "Éducation",
            subtitle: "Clarifier les engagements réciproques pour rétablir la continuité éducative",
            hasStructuredFormat: true,
            diagnostic: "Trop souvent, l'école et les familles fonctionnent en parallèle. Les règles ne sont pas claires, la communication est insuffisante, et la discipline se dégrade. Cela pèse sur les enseignants, ralentit les apprentissages et alimente les tensions.",
            proposition: "Nous proposons un \"Contrat École–Parents\" simple, lisible et signé à chaque inscription. Il fixe des engagements réciproques : présence, respect, hygiène, suivi minimal à la maison, et communication régulière. L'objectif : restaurer la continuité éducative.",
            implementation: "(1) Rédiger un modèle national en langage clair, déclinable localement.\n(2) Prévoir une version papier + une version digitale (SMS/WhatsApp) pour la communication.\n(3) Mettre en place une réunion d'accueil obligatoire en début d'année.\n(4) Créer un mécanisme de médiation simple (référent établissement) pour traiter les situations récurrentes.",
            impact: "Baisse des conflits, meilleure discipline, amélioration du suivi, meilleure stabilité de classe, et hausse du niveau d'apprentissage effectif."
          },
          {
            title: "Service civique territorial",
            tag: "Cohésion / Jeunesse",
            subtitle: "Renforcer le lien national par une expérience structurante de terrain",
            hasStructuredFormat: true,
            diagnostic: "La cohésion nationale s'affaiblit quand les jeunesses ne se rencontrent plus, quand les territoires se ferment, et quand l'expérience citoyenne se limite au discours. Il faut recréer du lien concret.",
            proposition: "Nous proposons un service civique territorial de six mois, volontaire mais fortement valorisé, permettant à des jeunes d'effectuer une mission utile dans une région différente : école, santé communautaire, environnement, sport, alphabétisation, appui aux collectivités.",
            implementation: "(1) Définir des missions simples, standardisées, et mesurables.\n(2) Accorder une bourse + un certificat officiel.\n(3) Offrir un bonus d'accès à certains concours/emplois publics ou formations (selon critères).\n(4) Évaluer et publier les résultats (missions réalisées, impact local, insertion).",
            impact: "Plus de cohésion, plus de discipline, plus d'expérience utile, et une jeunesse davantage actrice de la construction nationale."
          }
        ]
      }
    ],
    cta: {
      share: "Partager",
      comment: "Commenter",
      contribute: "Je contribue",
      readMore: "Lire la suite",
      collapse: "Réduire"
    },
    sections: {
      diagnostic: "Diagnostic",
      proposition: "Proposition",
      implementation: "Mise en œuvre",
      impact: "Impact attendu"
    }
  },
  en: {
    title: "Our proposals",
    subtitle: "Three transformations for a sovereign nation",
    axes: [
      {
        id: "institutional",
        title: "Institutional transformation",
        description: "Rebuild the State to truly serve citizens.",
        proposals: [
          { 
            title: "Creation of provinces in Côte d'Ivoire",
            tag: "Proximity",
            description: "We propose the creation of new territorial entities, endowed with political and economic prerogatives and their own legislative chambers.",
            fullText: "Foreign visitors' enthusiasm for the economic capital, Abidjan, never fades; they consider the city beautiful, with solid infrastructure. These same visitors often ignore that just an hour from Abidjan, electricity is scarce, secondary access roads deteriorate, and health infrastructure - with 1 doctor for 6,000 people! - is inadequate.\n\nWe propose the creation of new territorial entities, endowed with political and economic prerogatives and their own legislative chambers, whose mission will be to ensure harmonious economic and social development throughout Côte d'Ivoire."
          },
          { 
            title: "Transformation of the Senate",
            tag: "Legitimacy",
            description: "A Senate elected entirely as a representative chamber of territories would be the logical continuation of the establishment of provinces.",
            fullText: "The decision to establish a Senate resulted from the vision that one can benefit from the experience of seasoned sages. However, one can consider - as in many countries - that the Senate is above all a representative chamber of territories.\n\nA Senate elected entirely on this basis would be the logical continuation of the establishment of provinces and its legitimacy could be greater."
          },
          { 
            title: "Citizen panel",
            tag: "Participatory democracy",
            description: "Strengthen effective control of government action by civil society, through a participatory democracy procedure enshrined in the Constitution.",
            fullText: "The aim is to strengthen effective control of government and parliament action by civil society, through a participatory democracy procedure enshrined in the Constitution: the citizen panel.\n\nThis panel should be representative of the different components of society and renewable every two years."
          },
          {
            title: "Constructive opposition",
            tag: "Ethical governance",
            subtitle: "A public voting charter: support what is right, amend what is insufficient, fight what is dangerous",
            hasStructuredFormat: true,
            diagnostic: "Politics is too often perceived as automatic opposition or blind support. This logic weakens trust, fuels cynicism and gives the impression that parties seek conflict rather than results.",
            proposition: "We propose to formalize a constructive and contributive opposition posture: support useful texts, amend those that are perfectible, and fight those that are dangerous, ineffective or unjust.",
            implementation: "(1) Publish an \"ADA Voting Charter\" (permanent principle).\n(2) For each major text: produce a public sheet (1 page): position, amendments, reasons, expected impacts.\n(3) Set up monitoring: \"promise → vote → results\", with regular reporting.\n(4) Make amendment proposals accessible to the public.",
            impact: "More credibility, less fear, more trust — and an increased ability to win seats then elections through proof, not noise."
          },
          {
            title: "Local citizen budget",
            tag: "Territorial governance",
            subtitle: "Allocate a fixed share of municipal/regional budgets to citizen-chosen projects",
            hasStructuredFormat: true,
            diagnostic: "Citizens often feel that budget decisions are distant, opaque, and disconnected from real needs. This feeds distrust and weakens social control over public action.",
            proposition: "We propose that a fixed and regulated share of local budgets (e.g. 1% to 3%) be allocated to projects defined through simple and transparent citizen consultation.",
            implementation: "(1) Define a target percentage and standard regulation.\n(2) Implement anti-capture safeguards: rotation, transparency, audit, publication.\n(3) Require quarterly public reporting: progress, budget consumed, results.\n(4) Evaluate annually: satisfaction, deadlines, quality.",
            impact: "Strengthened trust, useful and visible projects, better local governance, and collective accountability."
          }
        ]
      },
      {
        id: "economic",
        title: "Economic transformation",
        description: "Create wealth in every territory.",
        proposals: [
          { 
            title: "National planning agency",
            tag: "Inclusive development",
            description: "A major agency to bridge development gaps between regions, with an operating budget and able to coordinate essential infrastructure deployment.",
            fullText: "We believe it is urgent to set up such an agency, with an operating budget and able to coordinate the deployment of essential infrastructure - schools, health, roads, internet connectivity - but also to support each province's economic strategy.\n\nThis agency would have a triple role of recommendation, execution and evaluation."
          },
          { 
            title: "Sectoral value chains",
            tag: "SME springboard",
            description: "Continue and strengthen actions to support Ivorian SME development through targeted sectoral strategy.",
            fullText: "We propose to continue and strengthen actions to support Ivorian SME development through a sectoral strategy.\n\nFor key sectors - agroprocessing, new technologies, transport and logistics - we would identify professions where service supply is weaker to strengthen skills where necessary.\n\nThe objective would be complete value chains enabling Ivorian SMEs to become more competitive suppliers to larger groups."
          },
          { 
            title: "Fair rules of the game",
            tag: "Equity",
            description: "Establish fair rules in the economic and administrative sphere, allowing everyone to participate according to their skills and merit.",
            fullText: "Côte d'Ivoire unfortunately remains known for high corruption levels. We believe this results from the absence of effective monitoring and sanctions for anti-competitive behavior.\n\nWe propose: (1) create effective competition law, (2) ensure equitable access to public contracts, and (3) limit behavior aimed at reducing competition."
          },
          {
            title: "1,000 supplier SMEs",
            tag: "SME / Employment",
            subtitle: "A national program to develop SMEs capable of supplying the State and large groups",
            hasStructuredFormat: true,
            diagnostic: "Part of the economy remains dominated by few players, while many SMEs remain too weak to access structuring markets (standards, quality, deadlines, financing). This slows employment and local value creation.",
            proposition: "We propose a \"1,000 Supplier SMEs\" program to structure Ivorian SMEs capable of meeting State and large group needs: quality, deadlines, compliance, and competitiveness.",
            implementation: "(1) Create a \"Supplier SME\" label with simple criteria.\n(2) Organize targeted training (standards, costs, logistics, digitalization).\n(3) Simplify access to tenders via a readable platform.\n(4) Establish contractual discipline: timely payment + sanctions for delays.\n(5) Deploy guarantee/factoring mechanism to avoid cash asphyxiation.",
            impact: "More jobs, stronger productive fabric, more competition, more innovation, and an economy less dependent on few players."
          },
          {
            title: "Agricultural logistics shock",
            tag: "Agriculture / Cost of living",
            subtitle: "Reduce post-harvest losses through secondary roads, storage and cold chain",
            hasStructuredFormat: true,
            diagnostic: "A significant part of agricultural production is lost after harvest: degraded secondary roads, lack of warehouses, absence of cold chain, transport disruption. These losses increase living costs and reduce producer incomes.",
            proposition: "We propose a three-year \"Agricultural Logistics Shock\" plan: priority rural tracks, storage micro-hubs, shared cold rooms, and more regular transport systems.",
            implementation: "(1) Map high-loss areas and prioritize 100 to 200 agricultural corridors.\n(2) Deploy micro-hubs (storage + cold) managed in local PPPs.\n(3) Implement indicator-based governance: tonnage saved, loss reduction, income increase.\n(4) Associate local transformation: packaging, labeling, quality standards.",
            impact: "Rising farmer incomes, lower food inflation, better product quality, and increased export competitiveness."
          }
        ]
      },
      {
        id: "social",
        title: "Social transformation",
        description: "Invest in human capital.",
        proposals: [
          { 
            title: "Houses of opportunity",
            tag: "Opportunities",
            description: "A national network of small centers bringing together internet connectivity infrastructure for digital skills acquisition and economic support.",
            fullText: "This national network would be composed of small centers bringing together internet connectivity infrastructure with two main objectives:\n\n(1) acquisition by children of new technology skills\n(2) supporting adults in developing local economic activities.\n\nIn the long term, we imagine these houses could also constitute the backbone of a national network of services to individuals/entrepreneurs."
          },
          { 
            title: "Memory caravan",
            tag: "Memory",
            description: "A journey to remember who we are and define what we want to become, going from village to village to gather Ivorian memory elements.",
            fullText: "A journey to remember who we are and define what we want to become. Such would be the mission of our caravan, going from village to village to gather all constituent elements of Ivorian memory.\n\nRemember, without nostalgia. Remember to rebuild."
          },
          {
            title: "Bi-seasonal school calendar",
            tag: "Education",
            subtitle: "A calendar adapted to climate and school performance",
            hasStructuredFormat: true,
            diagnostic: "The current school rhythm does not sufficiently account for climatic and health realities: periods of intense heat, rainy season, travel difficulties, seasonal disease peaks, fatigue. Result: absenteeism, decreased concentration, increased inequalities between urban and rural areas.",
            proposition: "We propose adapting the school calendar to a country living essentially to two seasons' rhythm, with a simple, readable national model, and a regulated local adjustment margin. The goal is not \"less school\", but a better organized, more regular, more effective school.",
            implementation: "(1) Launch pilots in 2 to 3 climatic zones for a complete school year.\n(2) Set a stable national framework, but allow regulated local adjustment (±10 to ±15 days) according to climatic realities.\n(3) Harmonize exams and revision periods to protect effective hourly volume.\n(4) Couple the reform with \"Cool School\" measures: ventilation, shading, schedule arrangements during heat peaks.",
            impact: "Less absenteeism, better school health, better performance, reduced territorial inequalities, and an organization more compatible with family life and local economy."
          },
          {
            title: "Awakening & Practice",
            tag: "Education",
            subtitle: "A weekly half-day dedicated to useful skills and practical application",
            hasStructuredFormat: true,
            diagnostic: "School is too often experienced as abstract: accumulation of knowledge, weak practical application, little openness to real life, and a deficit of structuring activities (sports, projects, civics, digital, arts). This weakens autonomy, critical thinking and future employability.",
            proposition: "We propose dedicating half a day per week to an \"Awakening & Practice\" program: observation, group projects, sports, civics, arts, digital, and entrepreneurship initiation. The school thus trains awakened children — and citizens in action.",
            implementation: "(1) Define a light national framework: themes, objectives, simple deliverables.\n(2) Deploy a standardized \"project notebook\" for students, with level progression.\n(3) Set up local partnerships (town halls, craftsmen, farms, associations, companies) to host or intervene.\n(4) Train one referent per establishment to coordinate and evaluate progression.",
            impact: "A more lively, more motivating school that develops concrete skills: collaboration, discipline, initiative, digital, health, civics and self-confidence."
          },
          {
            title: "School-Parent Contract",
            tag: "Education",
            subtitle: "Clarify reciprocal commitments to restore educational continuity",
            hasStructuredFormat: true,
            diagnostic: "Too often, school and families operate in parallel. Rules are not clear, communication is insufficient, and discipline deteriorates. This weighs on teachers, slows learning and fuels tensions.",
            proposition: "We propose a simple, readable \"School-Parent Contract\" signed at each enrollment. It sets reciprocal commitments: attendance, respect, hygiene, minimal home follow-up, and regular communication. The objective: restore educational continuity.",
            implementation: "(1) Draft a national model in clear language, locally adaptable.\n(2) Provide a paper version + a digital version (SMS/WhatsApp) for communication.\n(3) Set up a mandatory welcome meeting at the beginning of the year.\n(4) Create a simple mediation mechanism (establishment referent) to deal with recurring situations.",
            impact: "Fewer conflicts, better discipline, improved follow-up, better class stability, and higher effective learning level."
          },
          {
            title: "Territorial civic service",
            tag: "Cohesion / Youth",
            subtitle: "Strengthen national bonds through a structuring field experience",
            hasStructuredFormat: true,
            diagnostic: "National cohesion weakens when youth no longer meet, when territories close, and when civic experience is limited to discourse. We must recreate concrete bonds.",
            proposition: "We propose a six-month territorial civic service, voluntary but highly valued, allowing young people to carry out a useful mission in a different region: school, community health, environment, sports, literacy, support to local authorities.",
            implementation: "(1) Define simple, standardized, and measurable missions.\n(2) Grant a scholarship + an official certificate.\n(3) Offer access bonus to certain public competitions/jobs or training (based on criteria).\n(4) Evaluate and publish results (missions accomplished, local impact, integration).",
            impact: "More cohesion, more discipline, more useful experience, and youth more actively involved in national construction."
          }
        ]
      }
    ],
    cta: {
      share: "Share",
      comment: "Comment",
      contribute: "I contribute",
      readMore: "Read more",
      collapse: "Collapse"
    },
    sections: {
      diagnostic: "Diagnosis",
      proposition: "Proposal",
      implementation: "Implementation",
      impact: "Expected impact"
    }
  }
};
